import React, {useState, useRef} from 'react';
import { useHistory } from 'react-router-dom'; 
import '../../../css/submit.scss';

// function Submit(props) {
//     const buttonElement = useRef();
//     return (
//         <button className={`submit ${props.disable && 'disable-click'} ${(props.disable == 'button') && 'disable'}`} onClick={props.callFunction}>
//             <span>{props.actionText}</span>
//         </button>
//     )
// }

const Submit = ({actionText, callFunction, disable}) => {
    return (
        <button className={`submit ${disable && 'disable-click'} ${(disable == 'button') && 'disable'}`} onClick={callFunction}>
            {actionText}
        </button>
    )
}

export default Submit;


// import React, { useState } from 'react';

// const SubmitButton = ({ text, loadingText, onSubmit }) => {
//   const [isLoading, setIsLoading] = useState(false);

//   const handleClick = async () => {
//     setIsLoading(true);
//     try {
//         await onSubmit();
//         // setIsLoading(false);
//     } catch (error) {
//         await onSubmit();
//         console.error('error-message');
//         // setIsLoading(false);
//         // Handle or display the error as needed
//     }
//     // await onSubmit();
//     // setIsLoading(false);
//   };

//   return (
//     <button onClick={handleClick} disabled={isLoading}>
//       {isLoading ? loadingText : text}
//     </button>
//   );
// };

// export default SubmitButton;